export enum NotificationsHubEvents {
    ReceiveMessage = "ReceiveMessage",
    LoadConversationMessages = "LoadConversationMessages",
    LoadNavbarNotifications = "LoadNavbarNotifications",
    UpdateNavbarNotificationMsgs = "UpdateNavbarNotificationMsgs",
    LoadConversationList = "LoadConversationList",
    NewCallNotification = "NewCallNotification",
    CallStatusChange = "CallStatusChange",
    CallNotificationResponse = "CallNotificationResponse",
    FpCallNotificationResponse = "FpCallNotificationResponse",
    DeleteMessage = "DeleteMessage",
    EditMessage = "EditMessage",
    UndoDeleteMessage = "UndoDeleteMessage",
    AddedToConversation = "AddedToConversation",
    LeftConversation = "LeftConversation",
    EditConversationTitle = "EditConversationTitle",
    ReadAllMessages = "ReadAllMessages",
    ReadConversationNotification = "ReadConversationNotification",
    MessageReactionNotification = "MessageReactionNotification",
    UserStatusChange = "UserStatusChange"
}
